<template>
  <div class="medal-manager">
    <el-table
      :data="tableData"
      border
      stripe
      highlight-current-row="true"
      style="width: 100%; margin-top: 20px"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'text-align': 'center' }"
      class="custom-padding-table"
    >
      <el-table-column prop="name" label="促销活动名称" width="200">
      </el-table-column>
      <el-table-column prop="grade" label="产品类型" width="200">
        <template #default="scope">
            <span v-if="scope.row.productType==0">所有产品</span>
            <span v-if="scope.row.productType==1">所有单品</span>
            <span v-if="scope.row.productType==2">所有合集</span>
            <span v-if="scope.row.productType==3">部分产品</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="medalName" label="产品形式" width="200" >
         <template #default="scope">
          <span v-if="scope.row.productForm == -1">暂不显示</span>
          <span v-if="scope.row.productForm == 0">所有形式</span>
          <span v-if="scope.row.productForm == 1">视频</span>
          <span v-if="scope.row.productForm == 2">文档</span>
        </template>
      </el-table-column> -->
      <el-table-column
        label="促销类型"
        prop="conditionValue"
      >
       <template #default="scope">
          <el-tag type="success" v-if="scope.row.discountType == 1">折扣</el-tag>
          <el-tag v-if="scope.row.discountType == 2">优惠券</el-tag>
          <el-tag type="danger" v-if="scope.row.discountType == 3">满减</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="rankTexture" label="促销规则" width="200" >
         <template #default="scope">
          <span v-if="scope.row.discountType == 1">{{scope.row.discountRatio}}折</span>
          <span v-if="scope.row.discountType == 3">满{{scope.row.discountBasic}}减{{scope.row.discountValue}}</span>
        </template>
      </el-table-column>
      <el-table-column label="活动开始时间" prop="startTime"  width="200" />
      <el-table-column label="活动结束时间" prop="endTime"  width="200" />
      <el-table-column label="修改人" prop="updateUserName"> </el-table-column>
      <el-table-column label="修改时间" prop="updateTime"> </el-table-column>
    </el-table>

    <!--底部工具条-->
    <el-col :span="24" class="pageBar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages.pageIndex"
        :page-sizes="pages.pageArr"
        :page-size="pages.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount"
      >
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import { getPromotionUpdateRecordListApi } from "../../../api/api";

export default {
  name: "MedalManager",
  data() {
    return {
      filters: {
        promotionId : "",
      },
      // 勋章列表数据（初始化与图片一致）
      tableData: [],
      listLoading: false,
      //关于分页的obj
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
    };
  },

  methods: {
    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getList();
    },

    getList() {
      let params = {
        ...this.filters,
        pageIndex: this.pages.pageIndex,
        pageSize: this.pages.pageSize,
      };
      getPromotionUpdateRecordListApi(params).then((res) => {
        if (res.data.success) {
          console.log('res',res)
          this.tableData = res.data.response.data;
          this.pages.dataCount = res.data.response.dataCount;
        }
      });
    },
  },
  mounted() {
    this.filters = {
      promotionId : this.$route.query.id,
    };
    this.getList();
  },
};
</script>

<style lang="stylus" scoped>

.pageBar {
  margin-top: 15px;
}

/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table
  ::v-deep .el-table__cell
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px
    padding-bottom: 16px
    
  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell
    padding-top: 16px !important
    padding-bottom: 16px !important
/* 👆👆👆 新增的样式结束 👆👆👆 */


</style>